// extracted by mini-css-extract-plugin
export default {"container":"v2_container__seGQo","help":"v2_help__FHPHz","help__home":"v2_help__home__Tqry7","logo":"v2_logo__M+aaa","stars":"v2_stars__S5k5K"};